module.exports = __webpack_public_path__ + "static/media/mumbai.c80ca5a5.svg";